'use client';

export interface FormHeaderProps {
  title: string;
  step: number;
}

export function FormHeader({ title, step }: FormHeaderProps) {
  return (
    <div className="flex w-full items-center justify-between">
      <p className="text-lg font-bold tracking-tight text-black sm:text-xl">{title}</p>
      <span className="text-lg tracking-tight text-muted-foreground sm:text-xl">{step}/2</span>
    </div>
  );
}
